import { render } from "./BlogPage2.vue?vue&type=template&id=ff484470&scoped=true"
import script from "./BlogPage2.vue?vue&type=script&lang=js"
export * from "./BlogPage2.vue?vue&type=script&lang=js"

import "./BlogPage2.vue?vue&type=style&index=0&id=ff484470&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff484470"]])

export default __exports__